import { ProjectAttachmentType } from 'data/types';

export const LAYOUT_IMAGE_TYPE = 'floor_plan';
export const EQUIPMENT_IMAGE_TYPE = 'existing_equipment';

export type StructureImageTypeCode =
  | typeof LAYOUT_IMAGE_TYPE
  | typeof EQUIPMENT_IMAGE_TYPE;

export function isEquipmentAttachment(
  attachment: ProjectAttachmentType
): boolean {
  return attachment.imageType === EQUIPMENT_IMAGE_TYPE;
}

export function getEquipmentAttachments(
  attachments: ProjectAttachmentType[]
): ProjectAttachmentType[] {
  return attachments.filter(isEquipmentAttachment);
}

export function getLayoutAttachments(
  attachments: ProjectAttachmentType[]
): ProjectAttachmentType[] {
  return attachments.filter((attachment) => !isEquipmentAttachment(attachment));
}

export function getAttachmentsByType(
  attachments: ProjectAttachmentType[],
  imageType: StructureImageTypeCode
): ProjectAttachmentType[] {
  return imageType === EQUIPMENT_IMAGE_TYPE
    ? getEquipmentAttachments(attachments)
    : getLayoutAttachments(attachments);
}
